import React from 'react';
import {
  FTActionsResult,
  FTActionTypeEnum,
  FTTransactionResult,
} from '@block-explorer/entities';
import { Cep18ActionRow } from './Cep18ActionRow';

const ftResultActionNameMap = {
  [FTActionTypeEnum.Approve]: 'Granted transfer rights',
  [FTActionTypeEnum.Transfer]: 'Transferred',
  [FTActionTypeEnum.Burn]: 'Burned',
  [FTActionTypeEnum.Mint]: 'Minted',
};

const ftResultActionSenderPrefixesMap = {
  [FTActionTypeEnum.Transfer]: 'from',
  [FTActionTypeEnum.Approve]: 'to',
  [FTActionTypeEnum.Burn]: 'owned by',
};

export const DeployResultCep18 = ({
  ftAction,
}: {
  ftAction: FTTransactionResult;
}) => {
  const actionName: string = ftResultActionNameMap[ftAction.ft_action_type_id];
  const prefix: string | null =
    ftAction.ft_action_type_id === FTActionTypeEnum.Approve ? 'for' : null;
  const senderPrefix: string =
    ftResultActionSenderPrefixesMap[ftAction.ft_action_type_id];

  return (
    <Cep18ActionRow
      {...ftAction}
      contractPackage={ftAction.contract_package}
      actionName={actionName}
      prefix={prefix}
      senderPrefix={senderPrefix}
      from_hash={
        ftAction.ft_action_type_id === FTActionTypeEnum.Approve
          ? null
          : ftAction.from_hash
      }
    />
  );
};
